import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ClarityService {
    private readonly STAGING_CLARITY_ID = 'umcqmiu8gf';
    private readonly PRODUCTION_CLARITY_ID = 'umcpm1k89e';
    private loaded = false;

    loadClarity(): void {
        // Prevent loading multiple times
        if (this.loaded) {
            return;
        }

        // Determine which Clarity ID to use based on environment
        // Check if we're in staging by looking at the API URL or app URL
        const isStaging = !environment.production;
        
        const clarityId = isStaging ? this.STAGING_CLARITY_ID : this.PRODUCTION_CLARITY_ID;

        // Load Clarity script
        (function(c: any, l: Document, a: string, r: string, i: string, t: HTMLScriptElement | null, y: Node | null) {
            c[a] = c[a] || function() {
                (c[a].q = c[a].q || []).push(arguments);
            };
            t = l.createElement(r) as HTMLScriptElement;
            t.async = true;
            t.src = "https://www.clarity.ms/tag/" + i;
            y = l.getElementsByTagName(r)[0];
            if (y && y.parentNode) {
                y.parentNode.insertBefore(t, y);
            }
        })(window, document, "clarity", "script", clarityId, null, null);

        this.loaded = true;
    }
}

